import React from 'react'
import Slider from '../slider/Slider'
import Card from '../card/Card'

class Home extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <div >
                <Slider translateValue={400}></Slider>
                <div className="card-container">
                    <Card title="Productos">
                        <ul>
                            <li>Baldosa Lisa Tradicional.</li>
                            <li>Baldosa en Grano.</li>
                            <li>Baldosa en Grano para Exteriores.</li>
                            <li>Baldosa en Grano con Retal de Marmol.</li>
                            <li>Zócalo Lineal.</li>
                            <li>Zócalo en Media Caña.</li>
                            <li>Lavaderos en Granito.</li>
                            <li>Bases de Marmol.</li>
                        </ul>
                    </Card>
                    <Card title="Servicios">
                        <ul>
                            <li>Pulida de Pisos en Grano y Marmol.</li>
                            <li>Brillada de Pisos en Grano y Marmol.</li>
                            <li>Instación de Pisos.</li>
                        </ul>
                    </Card>
                </div>
            </div>
        )
    }
}
export default Home


// WEBPACK FOOTER //
// ./src/components/home/Home.jsx